<app-table
  [tableId]="tableId()"
  [data]="tableEntities()"
  [allColumns]="columns()"
  [config]="tableConfig"
  [referenceNames]="referenceNameLookup"
  class="block h-full" />
